import React, { Component } from 'react';
import axios from 'axios';


class ModifyStudent extends Component {
  state = {
    CourseTitle: null,
    windowHeight: window.innerHeight - 60,
    error: null,
    loading: false, // Added loading state
    courses: []
  };
  // for the image 
  fileInputRef = React.createRef();




//   api/list-courses

  FetchCourse  = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get("https://api.geoinfoacademy.com/api/list-courses", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      this.setState({ courses: response.data, loading: false });
      console.log("list of course API",response.data)
    } catch (error) {
      if (error.response) {
        // Server responded with a status code
        if (error.response.status === 401) {
          console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
          window.location.href = "/";
        } else {
          console.error("Error response from API:", error.response);
          this.setState({ loading: false });
        }
      } else if (error.code === "ERR_NETWORK") {
        console.error("Network error detected. Possibly no internet or server is down.");
        this.setState({loading: false  })
      } else {
        // Any other unexpected error
        console.error("Unexpected error:", error);
        this.setState({ loading: false });
      }
    }
  };

  


  // start of the handle submition


  handleInputChange = (event) => {
    const { name, value} = event.target;
      this.setState({ [name]: value });
  };
 
  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, error: null });
    const formData = {
        student_id : this.props.studentId
    }
    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.post(`https://api.geoinfoacademy.com/api/courses/${this.state.CourseTitle}/enroll/`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.setState({ CourseTitle: null});
      this.props.closeform()
    } catch (error) {
      console.error('Error submitting form:', error);
    }
    finally {
      this.setState({ loading: false }); // Set loading to false after response
    }
  };


  // end for the submition







  // the display
  handleOutsideClick = (event) => {
    if (this.node && !this.node.contains(event.target)) {
      this.props.closeform()
    }

  };
  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    document.addEventListener('mousedown', this.handleOutsideClick);
    this.FetchCourse()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    document.removeEventListener('mousedown', this.handleOutsideClick);
  }
  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  render() {
    const { menuCoverWidth, CourseTitle, courses } = this.state;

    const courseList = courses.length > 0 ? courses.map(list =>{
        return(
            <option value={list.id}>{list.title}</option>
        )
    }) : null

    return (

      <div className="dash_add_course_cover main" style={{ width: `calc(100% - ${menuCoverWidth}px - 3px)`, height: this.state.windowHeight, display: "flex" }}>
        <div className="dash_form_container" ref={(node) => (this.node = node)}>
          <h2>Enroll Student</h2>
          <p>Make sure you choose the right course to prevent unlocking for another  </p>
          <form onSubmit={this.handleSubmit} className='add_course_form'>

            <label htmlFor="title">Course Title</label><br />
            <select name='CourseTitle' id='CourseTitle' value={CourseTitle} onChange={this.handleInputChange} style={{marginBottom: "20px"}}>
                <option value={null}>Select Course Title</option>
                {courseList}
            </select>
           
            <button type="submit" disabled={this.state.loading}>
              {this.state.loading ? "Uploading..." : "Submit"}
            </button>
          </form>
        </div>
      </div>


    );
  }
}

export default ModifyStudent;